import React, { useMemo } from 'react';

const THEME_PROMPTS = {
  adventure: [
    "If you were on [title]'s adventure, what's the bravest thing you'd do?",
    "What makes someone a hero?",
  ],
  magic: [
    "If you had a magic power like in the story, what would yours be?",
    "What's the most magical thing you can imagine?",
  ],
  animals: [
    "Which animal in the story would you want as a friend and why?",
    "If you could talk to animals, what would you ask them?",
  ],
  space: [
    "If you could visit any planet, which would you choose?",
    "What would you bring on a rocket ship?",
  ],
  ocean: [
    "What do you think lives at the very bottom of the ocean?",
    "If you could breathe underwater, where would you explore?",
  ],
  friendship: [
    "What makes someone a great friend?",
    "How would you make a new friend feel welcome?",
  ],
  kindness: [
    "What's the kindest thing you've ever done for someone?",
    "How do you feel when someone is kind to you?",
  ],
  mystery: [
    "If you were a detective, what clues would you look for?",
    "What's the biggest mystery you'd want to solve?",
  ],
};

const DEFAULT_PROMPTS = [
  "What was your favourite part of the story?",
  "If you could change the ending, what would happen?",
];

function getPrompts(story, childName) {
  if (!story) return DEFAULT_PROMPTS;

  const themeKey = (story.theme || story.tags?.[0] || '').toLowerCase();
  const prompts = THEME_PROMPTS[themeKey] || DEFAULT_PROMPTS;

  return prompts.map((p) =>
    p.replace('[title]', childName || story.title || 'the character')
  );
}

const ReflectionPrompts = ({ story, childName }) => {
  const prompts = useMemo(() => getPrompts(story, childName), [story, childName]);

  return (
    <div
      className="rounded-4 p-3 mb-3"
      style={{
        background: 'var(--purple-section)',
        border: '1px solid var(--border-purple)',
      }}
    >
      <div
        className="fw-bold mb-2"
        style={{ fontSize: '13px', color: 'var(--text-main)' }}
      >
        💬 Ask {childName || 'your child'} tonight
      </div>
      <ul className="list-unstyled mb-0">
        {prompts.map((prompt, idx) => (
          <li
            key={idx}
            className="d-flex align-items-start gap-2 mb-2"
            style={{ fontSize: '13px', color: 'var(--text-body)' }}
          >
            <span style={{ flexShrink: 0 }}>💭</span>
            <span>{prompt}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ReflectionPrompts;
